import { useCallback, useState, useRef, useMemo } from "react";
import { useLayoutEffect } from "react";

const useScrollTrigger = (triggerPosition = -100, wait = 100) => {
  const triggerFixedPosition = Math.round(triggerPosition / 10) * 10 + 1.5;

  const prevScrolled = useRef();

  const [trigger, setTrigger] = useState({
    moreThanNumber: window.scrollY > triggerFixedPosition,
    scrolledUp: false,
  });

  useMemo(() => {
    prevScrolled.current = trigger.scrolledUp;
  }, [trigger]);

  const prevPosition = useRef();
  prevPosition.current = window.scrollY;

  let throttle = null;

  const validator = ({ prevPos, currPos }) => {
    if (prevPos > currPos && prevPos - currPos > 10) {
      return true;
    } else if (prevPos < currPos && currPos - prevPos > 10) {
      return false;
    } else {
      return trigger.scrolledUp;
    }
  };

  const callback = useCallback(() => {
    const currPos = window.scrollY;

    const isScrolledUp = validator({ prevPos: prevPosition.current, currPos });

    if ((currPos && prevPosition.current !== currPos) || currPos === 0) {
      if (
        prevPosition.current <= triggerFixedPosition &&
        currPos >= triggerFixedPosition
      ) {
        (trigger.scrolledUp !== false || trigger.moreThanNumber !== true) &&
          setTrigger({ scrolledUp: false, moreThanNumber: true });
      } else if (
        prevPosition.current >= triggerFixedPosition &&
        currPos <= triggerFixedPosition
      ) {
        (trigger.scrolledUp !== true || trigger.moreThanNumber !== false) &&
          setTrigger({ scrolledUp: true, moreThanNumber: false });
      }
    }

    if (isScrolledUp !== trigger.scrolledUp) {
      setTrigger({
        moreThanNumber: currPos > triggerFixedPosition,
        scrolledUp: isScrolledUp,
      });
    }

    throttle = null;

    prevPosition.current = window.scrollY;
  }, [trigger, validator]);

  useLayoutEffect(() => {
    const handleScroll = () => {
      if (throttle === null) {
        throttle = setTimeout(callback, wait);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [callback]);

  return trigger;
};
export default useScrollTrigger;
